export enum HomeImages {
  onDutyImage = '../../../assets/images/OnDuty.svg',
  offDutyImage = '../../../assets/images/OffDuty.svg',
  noLicenseImage = '../../../assets/images/NoLicense.svg',
  noConnectionImage = '../../../assets/images/NoConnection.svg',
}
